import {setupResearchCitations} from "pages/_research_citations";
import {closeMobileMenu} from "../layouts/_mobile_menu";
import "./events.scss";
import "./resources.scss";

declare var $: any;

const sections = ["conferences", "webinars", "in-person-events", "virtual-events"];

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll("section.sections-controller").length) {
    setupSections();
    setupResearchCitations();
    startCarousel();

    window.addEventListener("resize", startCarousel);
  }
});

const handleHashChange = () => {
  const sectionId = window.location.hash.substring(1);

  showSection(sections.includes(sectionId) ? sectionId : sections[0]);

  closeMobileMenu();
};

const setupSections = () => {
  handleHashChange();

  window.addEventListener("hashchange", handleHashChange, false);
};

const scrollToSectionIfNeeded = () => {
  const currentScrollTop = document.documentElement.scrollTop;
  const isMobile = window.innerWidth < 900;

  const sectionToScrollTo = document.querySelector(".section-content");

  const sectionToScrollToOffset = (sectionToScrollTo as HTMLElement | undefined)?.offsetTop;

  if (sectionToScrollToOffset && currentScrollTop > sectionToScrollToOffset) {
    if (isMobile) {
      window.scrollTo(0, sectionToScrollToOffset);
    } else {
      const navbarDesktopHeight = document
        .querySelector(".sticky-header")
        ?.getBoundingClientRect().height;

      if (navbarDesktopHeight) {
        window.scrollTo(0, sectionToScrollToOffset - navbarDesktopHeight);
      }
    }
  }
};

const showSection = (sectionId: string) => {
  hideAllSections();

  scrollToSectionIfNeeded();

  const section = document.querySelector<HTMLElement>(`section.${sectionId}`);
  if (section) {
    section.style.display = "block";
  }

  const activeSections = document.querySelectorAll<HTMLElement>(
    `section.sections-controller ul li.${sectionId}`,
  );
  Array.from(activeSections).map((activeSection) => {
    activeSection.classList.add("active");
  });
};

const hideSection = (section: string) => {
  const sectionContent = document.querySelector<HTMLElement>(`section.${section}`);
  if (sectionContent) {
    sectionContent.style.display = "none";
  }

  const sectionMenuItems = document.querySelectorAll<HTMLElement>(
    `section.sections-controller ul li.${section}`,
  );

  Array.from(sectionMenuItems).map((sectionMenuItem) => {
    sectionMenuItem.classList.remove("active");
  });
};

const hideAllSections = () => {
  sections.forEach((section) => {
    hideSection(section);
  });
};

const startCarousel = () => {
  const carouselWrapper = document.querySelector<HTMLElement>("#events-carousel");
  if (carouselWrapper) {
    const carouselEl = document.querySelector("#events-carousel .owl-carousel");

    if (carouselEl) {
      const container = document.querySelector<HTMLElement>(".container");

      if (container) {
        const paddingLeft = parseFloat(
          window.getComputedStyle(container, null).getPropertyValue("padding-left"),
        );
        const leftOffset = container.getBoundingClientRect().left;
        const paddingElements = document.querySelectorAll<HTMLDivElement>(".padding-element");

        for (let i = 0, len = paddingElements.length; i < len; i++) {
          const paddingElement = paddingElements[i];
          const cardLeftPadding = 15;

          if (paddingElement) {
            paddingElement.style.width = paddingLeft + leftOffset - cardLeftPadding + "px";
          }
        }
      }

      $("#events-carousel .owl-carousel").owlCarousel({
        autoWidth: true,
      });

      $("#events-carousel .owl-carousel").addClass("visible");
    }
  }
};
